import React from "react";
import { appUrl } from "@/constants";
import { WebViewUI } from "@/components/webview-ui";

export default function TermsOfServiceScreen() {
    const termsUrl = `${appUrl}/mobile/terms-and-conditions`;

    return (
         <WebViewUI title="Terms of Service" url={termsUrl} />
    );
}
